module.exports = __webpack_public_path__ + "static/media/pro-vouchar.019982c4.png";